module.exports = __webpack_public_path__ + "static/media/why_pl.0fd46fc0.vtt";